import React from 'react';
import { calculateOutgoing, calculateIncoming } from '../trackingCalculations';

const formatAmount = (value) => {
  const num = parseFloat(value) || 0;
  const prefix = num < 0 ? '-$' : '$';
  return `${prefix}${Math.abs(num).toFixed(2)}`;
};

const PhoneMobileEquation = ({ trackingPeriod, state, setShowUpdateBalance }) => {
  const outgoingAmount = calculateOutgoing(trackingPeriod, state);
  const incomingAmount = calculateIncoming(trackingPeriod, state);
  const currentBalance = parseFloat(state.currentBalance || 0);
  const closingBalance = currentBalance - outgoingAmount + incomingAmount;
  const isNegative = closingBalance < 0;

  return (
    <div className="phone-bills-equation-compact">
      <button
        type="button"
        className="phone-bills-eq-cell phone-bills-eq-cell--balance"
        onClick={() => setShowUpdateBalance(true)}
        aria-label="Update balance"
      >
        <span className="phone-bills-eq-label">Balance</span>
        <span className="phone-bills-eq-value">{formatAmount(currentBalance)}</span>
      </button>
      <span className="phone-bills-eq-op" aria-hidden="true">
        −
      </span>
      <div className="phone-bills-eq-cell phone-bills-eq-cell--out">
        <span className="phone-bills-eq-label">Out</span>
        <span className="phone-bills-eq-value">{formatAmount(outgoingAmount)}</span>
      </div>
      <span className="phone-bills-eq-op" aria-hidden="true">
        +
      </span>
      <div className="phone-bills-eq-cell phone-bills-eq-cell--in">
        <span className="phone-bills-eq-label">In</span>
        <span className="phone-bills-eq-value">{formatAmount(incomingAmount)}</span>
      </div>
      <span className="phone-bills-eq-op" aria-hidden="true">
        =
      </span>
      <div
        className={`phone-bills-eq-cell phone-bills-eq-cell--close${
          isNegative ? ' phone-bills-eq-cell--negative' : ''
        }`}
      >
        <span className="phone-bills-eq-label">Left</span>
        <span className="phone-bills-eq-value">{formatAmount(closingBalance)}</span>
      </div>
    </div>
  );
};

export default PhoneMobileEquation;
